import { render } from "./TableRow.vue?vue&type=template&id=71ed13ca"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"
script.render = render

export default script